import { selectAnatomy } from '@chakra-ui/anatomy'
import { createMultiStyleConfigHelpers, defineStyle } from '@chakra-ui/react'
import { textStyles } from '../foundations/textStyles'

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(selectAnatomy.keys)

const size = {
  xs: defineStyle({
    ...textStyles.xs,
  }),
  sm: defineStyle({
    ...textStyles['sm'],
  }),
  md: defineStyle({
    ...textStyles['md'],
  }),
  lg: defineStyle({
    ...textStyles['lg'],
  }),
}

const sizes = {
  xs: definePartsStyle({
    field: size.xs,
    icon: {
      insetEnd: '2',
    },
  }),
  sm: definePartsStyle({
    field: size.sm,
    icon: {
      insetEnd: '3',
    },
  }),
  md: definePartsStyle({
    field: size.md,
    icon: {
      insetEnd: '4',
    },
  }),
  lg: definePartsStyle({
    field: size.lg,
    icon: {
      insetEnd: '4',
    },
  }),
}

const baseStyleIcon = defineStyle({
  width: '2.5',
  height: '2.5',
})

const baseStyle = definePartsStyle({
  icon: baseStyleIcon,
})

export const Select = defineMultiStyleConfig({
  sizes,
  baseStyle,
  defaultProps: {
    variant: 'outline',
  },
})
